import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { VariableLocalSesionService } from 'new-sysman-ui';
import { tap } from 'rxjs/operators';

/**
 * Interceptor que intercepta la respuesta de obtenerGruposUsuario
 * y guarda automáticamente:
 * - id_grupo e id_aplicaciones (primer grupo)
 * - grupos_usuario: mapa { [aplicacion]: id_grupo } con todos los grupos
 *
 * @author jmedina
 * @version 1.0.0
 * @since 2026-05-05
 */
export const guardarGrupoUsuarioInterceptor: HttpInterceptorFn = (req, next) => {
  const variablesSesion = inject(VariableLocalSesionService);

  return next(req).pipe(
    tap((event) => {
      if (event instanceof HttpResponse && req.url.includes('frmgruposdelusuario')) {
        const body = event.body as any;
        if (body?.codigo === 0 && body?.cuerpo?.datos?.length > 0) {
          // Guardar mapa completo: { aplicacion: id_grupo }
          const gruposMap: Record<number, number> = {};
          body.cuerpo.datos.forEach((g: any) => {
            gruposMap[g.id_aplicaciones] = g.id_grupo;
          });
          variablesSesion.setData('grupos_usuario', gruposMap);

          // Primer grupo como default
          const primerGrupo = body.cuerpo.datos[0];
          variablesSesion.setData('id_grupo', primerGrupo.id_grupo);
          variablesSesion.setData('id_aplicaciones', primerGrupo.id_aplicaciones);
        } else {
          console.warn(
            '[Interceptor] No se procesaron grupos. codigo:',
            body?.codigo,
            'datos:',
            body?.cuerpo?.datos?.length,
          );
        }
      }
    }),
  );
};
